import { Button, Card, CardActions, CardContent, Chip, Grid, Typography } from "@mui/material";
import { format } from "date-fns";
import React from "react";
import { confirmAlert } from 'react-confirm-alert';
import { WeekLongString } from '../../Helper/Week';
import { ChargeCategory } from "../../Objects/ChargeCategory";
import { ChargePattern } from "../../Objects/ChargePattern";
import ChargeCategoryText from "../atoms/ChargeCategoryText";

export interface ChargePatternCardProps {
    chargePattern: ChargePattern
    chargeCategoryList: ChargeCategory[]
    onDelete: () => void
    onEdit: () => void
}

const ChargePatternCard: React.FC<ChargePatternCardProps> = ({
    chargePattern,
    chargeCategoryList,
    onDelete,
    onEdit,
}) => {

    return (
        <>
            <Card variant="outlined">
                <CardContent>
                    <Grid container spacing={0.5} alignItems="center">
                        <Grid item xs={12} md={3.5} sx={{
                            textAlign: {
                                md: "right",
                                xs: "left"
                            },
                            paddingRight: 2
                        }}>
                            <Typography variant="caption" sx={{ color: "#333399" }}>適用日</Typography>
                        </Grid>
                        <Grid item xs={12} md={8.5}>
                            {(chargePattern.start_date || chargePattern.end_date) ? (
                                <Typography>{chargePattern.start_date && format(chargePattern.start_date, "yyyy年MM月dd日")} ～ {chargePattern.end_date && format(chargePattern.end_date, "yyyy年MM月dd日")}</Typography>
                            ) : (
                                <Typography>-</Typography>
                            )}
                        </Grid>
                        <Grid item xs={12} md={3.5} sx={{
                            textAlign: {
                                md: "right",
                                xs: "left"
                            },
                            paddingRight: 2
                        }}>
                            <Typography variant="caption" sx={{ color: "#333399" }}>料金カテゴリ</Typography>
                        </Grid>
                        <Grid item xs={12} md={8.5}>
                            <ChargeCategoryText
                                chargeCategory={chargeCategoryList.find(value => value.chrcate_id == chargePattern.chrcate_id)}
                                withTooltip
                            />
                        </Grid>
                        <Grid item xs={12} md={3.5} sx={{
                            textAlign: {
                                md: "right",
                                xs: "left"
                            },
                            paddingRight: 2
                        }}>
                            <Typography variant="caption" sx={{ color: "#333399" }}>適用曜日</Typography>
                        </Grid>
                        <Grid item xs={12} md={8.5}>
                            {chargePattern.week_conditions?.map((week, index) => (
                                <Chip
                                    key={index}
                                    label={WeekLongString[week]}
                                    size="small"
                                    variant="outlined"
                                    sx={{
                                        mr: 1,
                                        my: 0.5
                                    }}
                                />
                            ))}
                        </Grid>
                        <Grid item xs={12} md={3.5} sx={{
                            textAlign: {
                                md: "right",
                                xs: "left"
                            },
                            paddingRight: 2
                        }}>
                            <Typography variant="caption" sx={{ color: "#333399" }}>適用時間</Typography>
                        </Grid>
                        <Grid item xs={12} md={8.5}>
                            {(chargePattern.start || chargePattern.end) ? (
                                <Typography>{chargePattern.start && chargePattern.start.toStringHM()} ～ {chargePattern.end && chargePattern.end.toStringHM()}</Typography>
                            ) : (
                                <Typography>-</Typography>
                            )}

                        </Grid>
                        <Grid item xs={12} md={3.5} sx={{
                            textAlign: {
                                md: "right",
                                xs: "left"
                            },
                            paddingRight: 2
                        }}>
                            <Typography variant="caption" sx={{ color: "#333399" }}>料金</Typography>
                        </Grid>
                        <Grid item xs={12} md={8.5}>
                            <Typography>{chargePattern.chrptn_charge?.toLocaleString()}円/1コマ</Typography>
                        </Grid>
                    </Grid>
                </CardContent>
                <CardActions
                    sx={{
                        display: "flex",
                        justifyContent: "right"
                    }}
                >
                    <Button size="small" color="error" variant="outlined"
                        onClick={() => {
                            confirmAlert({
                                title: "削除しますか？",
                                message: "削除を取り消すことはできません。ご注意ください。",
                                buttons: [
                                    {
                                        label: "削除する",
                                        onClick: () => {
                                            onDelete()
                                        }
                                    }, {
                                        label: "キャンセル",
                                        onClick: () => { }
                                    }
                                ]
                            })
                        }}
                    >削除</Button>
                    <Button size="small" variant="outlined"
                        onClick={() => {
                            onEdit()
                        }}
                    >編集</Button>
                </CardActions>
            </Card>
        </>
    )
}

export default ChargePatternCard